<template>
    <div>
        <template v-if="risk">
            <risk-header :risk="risk" :showResponsePanel="responsePanel" @showResponsePanel="showResponsePanel" />

            <component
                v-if="pageComponent"
                :is="pageComponent"
                :showResponsePanel="responsePanel"
                @closeResponsePanel="responsePanel = false"
                @updateRiskStatus="updateRiskStatus"
            />
        </template>

        <template v-else>
            <loading-spinner />
        </template>
    </div>
</template>

<script>
    import RiskHeader from '~/components/Shared/Partials/RiskHeader';
    import InsurerSubmissionPage from './InsurerRisk/InsurerSubmissionPage';
    import InsurerDeclarationSummary from './InsurerRisk/InsurerDeclarationSummary';

    export default {
        name: 'InsurerRisk',
        components: {
            RiskHeader,
            InsurerSubmissionPage,
            InsurerDeclarationSummary,
        },
        data() {
            return {
                risk: false,
                responsePanel: false
            }
        },
        computed: {
            pageComponent() {
                if (this.risk) {
                    switch (this.risk.status) {
                        case 'requested':
                        case 'offered':
                        case 'firm_order':
                        case 'accepted':
                        case 'declined':
                        case 'closed':
                        case 'ntu':
                            return 'insurer-submission-page';
                        case 'bound':
                        case 'expired':
                        case 'off_risk':
                            return 'insurer-declaration-summary';
                        default:
                            // no status matched
                    }
                }
            }
        },
        watch: {
            '$route.fullPath'() {
                this.risk = false;
                this.loadRisk(this.$route.params.id);
            }
        },
        mounted() {
            this.loadRisk(this.$route.params.id);
        },
        methods: {
            async loadRisk(riskId) {
                this.risk = (await axios.get(this.$root.api(`insurer/risk/${riskId}`))).data.data;
            },
            showResponsePanel() {
                this.responsePanel = true;
            },
            updateRiskStatus(status) {
                this.risk.status = status;
            }
        }
    }
</script>

<style lang="scss" scoped>
    header {
        animation: fade-in 1s;
    }
</style>
